// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Connection } from '@shared/commons/Connection';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { FullLogsItem } from '../cache/FullLogsItem';
import { TerceraQuickTreeEvents } from '../elements/QuickTree/TerceraQuickTree';
import { QuickTreeViewScreen } from '../screen/QuickTreeViewScreen';
import { PanelNames } from '../UtilsClasses/FactoryConstants';
import FullLogPanelTemplate from '@front/templates/FullLogPanelTemplate.html';
import { ApplicationPanelWithTable } from './ApplicationPanelWithTable';
import { ThemeManager } from '../misc/ThemeManager';
import { Color } from '@shared/commons/Graphics';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class FullLogsPanel extends ApplicationPanelWithTable {
    constructor() {
        super(...arguments);
        this.headerLocaleKey = 'ribbon.tools.full_logs';
        this.loggingStarted = false;
        this.codesTB = null;
        this.codesCB = null;
        this.startLogginBtn = null;
        this.addBtn = null;
        this.Filter = null;
        this.forceCloseOnLogout = false;
    }
    getType() {
        return PanelNames.FullLogsPanel;
    }
    jbInit() {
        super.jbInit();
        this.startLogginBtn = this.Controls.startLoggin;
        this.codesCB = this.Controls.codesCBFullLog;
        this.addBtn = this.Controls.add;
        this.codesTB = this.Controls.codesTBFullLog;
    }
    oncomplete() {
        super.oncomplete();
        this.center();
        this.FillCB();
        this.populateTableContextMenu();
        this.loggingStarted = false;
        this.Filter = {};
        this.localize();
        this.getQuickTable().AddToEnd = false;
        this.quickTableRactive.on(TerceraQuickTreeEvents.DoubleClick, this.ShowMoreInformation.bind(this));
    }
    setEnable(enable) {
        // this.startLogginBtn.set({ enabled: enable });
        void this.codesCB.set({ enabled: enable });
        void this.addBtn.set({ enabled: enable });
        void this.codesTB.set({ enabled: enable });
    }
    OnNewMessageHandler(info) {
        if (this.Filter.FiltersCount !== 0) {
            if (!this.Filter[info.MessageCode]) {
                return;
            }
        }
        info.dateTime = new Date();
        const row = this.getQuickTable().AddItem(new FullLogsItem(info));
        const isOutgoingMSG = info.IsOutgoingMSG;
        if (isOutgoingMSG) {
            row.BackColor = ThemeManager.colors.FullLogPanel_OutgoingMessageBackColor;
            row.ForeColor = Color.Black;
        }
    }
    populateTableContextMenu() {
        const items = [];
        this.AddExportContextMenuItem(items);
        this.getQuickTable().setTableContextMenuItems(items);
    }
    StartStopLogging() {
        if (!this.loggingStarted) {
            const text = this.codesTB.get('text');
            const fArr = text.split(',');
            for (let i = 0; i < fArr.length; i++) {
                if (fArr[i].trim() !== '') {
                    this.Filter[fArr[i].trim()] = true;
                }
            }
            this.Filter.FiltersCount = Object.keys(this.Filter).length;
            Connection.SubscribeOnFullLoging(this.OnNewMessageHandler.bind(this));
            void this.startLogginBtn.set({ text: 'Stop logging' });
            this.setEnable(false);
        }
        else {
            this.Filter = {};
            Connection.UnSubscribeOnFullLoging();
            void this.startLogginBtn.set({ text: 'Start logging' });
            this.setEnable(true);
        }
        this.loggingStarted = !this.loggingStarted;
    }
    ShowMoreInformation() {
        const qt = this.getQuickTable();
        const selectedRows = qt.selectedRowIds;
        if (selectedRows.length === 0) {
            return;
        }
        const selectedRow = qt.rows[selectedRows[0]];
        if (isNullOrUndefined(selectedRow)) {
            return;
        }
        QuickTreeViewScreen.Show(selectedRow.item.info.DataForTreeView);
    }
    AddMsgCodeForLogging() {
        const CBItem = this.codesCB.get('selectedItem');
        const value = CBItem.value;
        let text = this.codesTB.get('text');
        text += value + ', ';
        void this.codesTB.set('text', text);
    }
    ClearTable() {
        this.getQuickTable().ClearRows();
    }
    FillCB() {
        const msgDict = Connection.GetMessagesList();
        const items = [];
        const objectKeys = Object.keys(msgDict);
        for (let i = 0; i < objectKeys.length; i++) {
            items.push({
                type: NewContextMenuItemType.Default,
                text: msgDict[objectKeys[i]] + '(' + objectKeys[i] + ')',
                value: objectKeys[i]
            });
        }
        void this.codesCB.set({ items });
    }
    dispose() {
        Connection.UnSubscribeOnFullLoging();
        super.dispose();
        MainWindowManager.FullLogPanel = null;
    }
}
function ShowFullLogPanel() {
    if (!isNullOrUndefined(MainWindowManager.FullLogPanel)) {
        return;
    }
    const newPanel = new FullLogsPanel();
    MainWindowManager.AddControl(newPanel);
    MainWindowManager.FullLogPanel = newPanel;
}
export function logs() {
    if (isNullOrUndefined(MainWindowManager.FullLogPanel)) {
        ShowFullLogPanel();
    }
}
ApplicationPanelWithTable.extendWith(FullLogsPanel, {
    Name: 'FullLogsPanel',
    data: function () {
        return {
            showHeader: true,
            showFooter: false,
            dockablePanel: false,
            attached: false,
            resizable: true,
            width: 850,
            height: 300,
            canLinkByAccount: false
        };
    },
    partials: {
        bodyPartial: FullLogPanelTemplate
    }
});
